import React from 'react';

import PropTypes from 'prop-types';

import { CIRCLE, Skeleton, SQUARE } from './Skeleton';

type SkeletonListProps = {
    className?: string;
    type: typeof CIRCLE | typeof SQUARE;
    count: number;
};

const SkeletonList = ({ className, type, count }: SkeletonListProps) => {
    return Array.from(Array(count).keys()).map((item) => (
        <Skeleton key={item} className={className} type={type} />
    ));
};

SkeletonList.propTypes = {
    className: PropTypes.string,
    type: PropTypes.string,
    count: PropTypes.number
};

export default SkeletonList;
